module.exports = __webpack_public_path__ + "static/img/env08.7016131.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env08.png
// module id = 101
// module chunks = 4